export default __webpack_public_path__ + "static/media/roadmap-glow3.83e8276a.png";